<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-29 10:20:26
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-13 18:43:47
 * @Description: 显示赔率等信息
-->
<template>
    <CasinoGameBarWinning
        class="mt-[10px]"
        :percentage="getWinPercentage()"
        :mutipler="getFixed(Number(caculateMutipler))"
        :expectedReward="getFixed(Number(calculateExpectedReward))"
    >
    </CasinoGameBarWinning>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';

const t = useTranslation();

const props = defineProps({
    config: Object,
    labelRange: Object,
    isIn: Boolean,
    betAmount: Number,
    rtp: String,
    limitPayout: [String, Number],
});

const emit = defineEmits(['expectedReward']);

// ↓ 胜率
const getWinPercentage = () => {
    const { min, max } = props.labelRange;
    if (props.isIn) {
        const maxBuffer = props.config.max - max;
        const minBuffer = min - props.config.min;
        const percentage = (props.config.max - maxBuffer - minBuffer + 1) / 100;
        return percentage.toFixed(2);
    } else {
        const maxBuffer = props.config.max - max;
        const minBuffer = min - props.config.min;
        const totalBuffer = maxBuffer + minBuffer;
        return Number(((totalBuffer / props.config.max) * 100).toFixed(3));
    }
};

// ↓ 返现倍率  
const caculateMutipler = computed(() => {
    // Over limit: use maxWin logic
    const betAmount = Number(props.betAmount);
    const maxWin = Number(props.limitPayout);
    const rtp = Number.parseFloat(props.rtp || '0');
    if (betAmount > 0 && maxWin > 0) {
        // Calculate normal reward
        const rawPct = getWinPercentage();
        const iNumber = Number(rawPct);
        const normalMultiplier = (rtp / iNumber);
        const normalReward = betAmount * normalMultiplier;
        if (normalReward > maxWin) {
            // Over limit: fix multiplier so reward = maxWin
            
            showNegativeNotify({
                type: 'warning',
                position: 'top',
                message:t.commonInfo.payoutOverLimit.replace('{limit}', maxWin)
            })
            return (maxWin / betAmount).toFixed(5);
        }
        return normalMultiplier.toFixed(5);
    }
    // fallback
    const rawPct = getWinPercentage();
    const iNumber = Number(rawPct);
    const coeff = rtp;
    const sResult = (coeff / iNumber).toFixed(5);
    return sResult;
});

const iMinValue = 0.00000001;
const calculateExpectedReward = computed(() => {
    const betAmount = Number(props.betAmount);
    const maxWin = Number(props.limitPayout);
    if (betAmount === 0) {
        emit('expectedReward', 0);
        return 0;
    }
    if (betAmount <= iMinValue) {
        emit('expectedReward', iMinValue);
        return iMinValue;
    }
    const reward = betAmount * Number(caculateMutipler.value);
    if (maxWin > 0 && reward > maxWin) {
        emit('expectedReward', maxWin);
        return maxWin;
    }
    emit('expectedReward', Math.max(reward, iMinValue));
    return reward;
});

</script>

<style scoped lang="scss"></style>
